import { React, useState } from "react";
import classes from './VideoModal.module.scss'

//MUI Imports
import CloseIcon from '@mui/icons-material/Close';

function VideoModal({schema}){

    const [isActive, setActive] = useState(false);

    const toggleClass = () => {
      setActive(!isActive);
    };
    
    return (
        <div> 
            <div className={`${classes.VideoModal__content}`}> 
                <p className="small_copy">Need Help? <span onClick={() => { toggleClass() }}>Watch a guide video</span> or <a href={schema.screenContent.header.contact.address}>get in touch</a></p>
            </div>
            <div className={isActive ?  classes.VideoModal__active :  classes.VideoModal__disabled} >
                <div className={`${classes.VideoModal__video_content}`}>
                    <div
                        onClick={() => { toggleClass() }} 
                        className={`${classes.VideoModal__close_button}`}
                    >
                        <CloseIcon />
                    </div>
                    <div className={`${classes.VideoModal__video_wrapper}`}>

                        
                        <video className={`${classes.VideoModal__video}`} 
                            src="https://gest.cdn.node-production.com/tags/deploy-dev-1-0-7/ExampleProjectVideo.mp4" 
                            type="video/mp4"
                            poster={`${process.env.PUBLIC_URL}/assets/images/VideoPosterImage.jpg`}
                            controls
                        />

                        
                        

                    </div>
                    
                </div>

                
            </div>
            
        </div>
    );

}
export default VideoModal